import { formatDateForDatabase } from "./dateUtils";

export type DashboardPeriod = 'today' | 'week' | 'month' | 'year';

export interface DateRange {
  startDate: string;
  endDate: string;
}

/**
 * Calculate date range based on dashboard filter period
 * @param period - The filter period (today, week, month, year)
 * @returns Object with startDate and endDate in YYYY-MM-DD format
 */
export const calculateDateRange = (period: DashboardPeriod): DateRange => {
  const now = new Date();
  let startDate: Date;
  let endDate: Date;

  switch (period) {
    case 'today':
      // Today: 00:00 to 23:59
      startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
      endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      break;

    case 'week':
      // Week: Monday to Sunday of current week
      const dayOfWeek = now.getDay();
      const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Sunday is 0
      startDate = new Date(now);
      startDate.setDate(now.getDate() - daysToMonday);
      startDate.setHours(0, 0, 0, 0);
      
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      endDate.setHours(23, 59, 59, 999);
      break;

    case 'month':
      // Current month: 1st to last day
      startDate = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
      endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
      break;

    case 'year':
      // Current year: Jan 1 to Dec 31
      startDate = new Date(now.getFullYear(), 0, 1, 0, 0, 0);
      endDate = new Date(now.getFullYear(), 11, 31, 23, 59, 59);
      break;

    default:
      // Default to current month
      startDate = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
      endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
  }

  return {
    startDate: formatDateForDatabase(startDate),
    endDate: formatDateForDatabase(endDate),
  };
};
